import './ProjectForm.scss'
import {useRef, useState, useEffect, useContext } from 'react'
import { ProjectsContext } from '../../utils/ProjectsContext'
import { API_URL } from '../../utils/constants'
import { v4 as uuidv4 } from 'uuid'
import DNDGallery from '../../components/DNDGallery/DNDGallery'
import DOMPurify from 'dompurify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faXmark} from '@fortawesome/free-solid-svg-icons'
import Loader from '../Loader/Loader'
import welcomeImage from '../../assets/welcome01.png'
import ConfirmBox from '../ConfirmBox/ConfirmBox'
import ErrorText from '../ErrorText/ErrorText'
import ValidBox from '../ValidBox/ValidBox'



function ProjectForm({
    projectEdit,
    projectFormMode,
    artistsList,
    setArtistsList,
    productionList,
    setProductionList,
    pressList,
    setPressList,
    linksList,
    setLinksList,
    diffusionList,
    setDiffusionList,
    imageFiles, 
    setImageFiles,
    moImageFiles, 
    setMoImageFiles, 
    mainImageIndex,
    mainMoImageIndex, 
    setMainImageIndex,
    setMainMoImageIndex,
    setHandleDisplayProjectForm,
    handleDisplayProjectForm,
    handleLoadProjects
    })

    {

    const inputProjectTitleRef = useRef(null);
    const inputProjectSubtitleRef = useRef(null);
    const inputCreationDateRef = useRef(null);
    const inputProjectInfosRef = useRef(null);
    const inputMoreInfosRef = useRef(null);
    const inputAboutShowRef = useRef(null);
    const inputAboutScenoRef = useRef(null);
    const inputSummaryRef = useRef(null);
    const inputProjectTypeRef = useRef(null);
    const inputProjectImageFileRef = useRef(null);
    const inputProjectMoImageFileRef = useRef(null);
    const projectMainImageSampleRef = useRef(null);
    const projectMainMoImageSampleRef = useRef(null);
    const inputProjectSlugRef = useRef(null);

    const cleanedAboutSceno = DOMPurify.sanitize(projectEdit.aboutSceno);
    const cleanedAboutShow = DOMPurify.sanitize(projectEdit.aboutShow);
    const cleanedSummary = DOMPurify.sanitize(projectEdit.summary);
    
    const [projectTitle, setProjectTitle] = useState(projectFormMode === 'edit' ? projectEdit.title : '');
    const [projectSubtitle, setProjectSubtitle] = useState(projectFormMode === 'edit' ? projectEdit.subtitle : '');
    const [creationDate, setCreationDate] = useState(projectFormMode === 'edit' ? projectEdit.creationDate : '');
    const [projectInfos, setProjectInfos] = useState(projectFormMode === 'edit' ? projectEdit.projectInfos : '');
    const [moreInfos, setMoreInfos] = useState(projectFormMode === 'edit' ? projectEdit.moreInfos : '');
    const [aboutShow, setAboutShow] = useState(projectFormMode === 'edit' ? cleanedAboutShow : '');
    const [aboutSceno, setAboutSceno] = useState(projectFormMode === 'edit' ? cleanedAboutSceno : '');
    const [summary, setSummary] = useState(projectFormMode === 'edit' ? cleanedSummary : '');
    const [projectType, setProjectType] = useState(projectFormMode === 'edit' ? projectEdit.projectType : '');
    const [projectSlug, setProjectSlug] = useState(projectFormMode === 'edit' ? projectEdit.slug : '');

    const [displayServerError, setDisplayServerError] = useState(false);
    const [displayError, setDisplayError] = useState(false);
    const [displayValidBox, setDisplayValidBox] = useState(false);

    const { loaderDisplay, setLoaderDisplay, projectCategories, productionCategories } = useContext(ProjectsContext);

    /*------------------------------
    ----- OUVERTURE CONFIRMBOX -----
    ------------------------------*/
    const [confirmBoxState, setConfirmBoxState] = useState (false);
    /*------------------------------------
    ----- FERMETURE CONFIRMBOX -----
    ------------------------------------*/
    function closeConfirmBox() {
        setConfirmBoxState(false);
    }

    /*------------------------------------
    ----- OUVERTURE VALIDBOX -----
    ------------------------------------*/
    const openValidBox = () => {
        setDisplayValidBox(true);
        setTimeout(() => {
            setDisplayValidBox(false);
            closeForm();
        }, 2000); // Masquer la boîte après 2 secondes (2000 ms)
    };
    /*------------------------------------
    ----- ON NETTOIE LE SLUG PUIS ON MET UN SLUG PAR DEFAUT VIA LE TITRE-----
    ------------------------------------*/
    function slugify(value) {
        return value
            ?.normalize('NFD') // sépare les accents
            .replace(/[\u0300-\u036f]/g, '') // supprime les accents
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\s-]/g, '') // supprime caractères spéciaux
            .replace(/\s+/g, '-') // remplace espaces par tirets
            .replace(/-+/g, '-'); // évite les doubles tirets
    }

    useEffect(() => {
        if (projectFormMode === 'add') {
            setProjectSlug(slugify(projectTitle));
        }
    }, [projectTitle, projectFormMode]);

    // Réinitialisation des valuers input lorsque le formulaire s'ouvre / se ferme.
    useEffect(() => {
        console.log(creationDate);
      if (projectFormMode === 'edit') {
        setProjectTitle(projectEdit.title);
        setProjectSubtitle(projectEdit.subtitle);
        setProjectSlug(projectEdit.slug || slugify(projectEdit.title));
        setCreationDate(projectEdit.creationDate);
        setProjectInfos(projectEdit.projectInfos);
        setMoreInfos(projectEdit.projectInfos);
        setAboutShow(projectEdit.aboutShow);
        setAboutSceno(projectEdit.aboutSceno);
        setSummary(projectEdit.summary);
        setProjectType(projectEdit.projectType);
      } else {
        setProjectTitle('');
        setProjectSubtitle('');
        setProjectSlug('');
        setCreationDate('');
        setProjectInfos('');
        setMoreInfos('');
        setAboutShow('');
        setAboutSceno('');
        setSummary('');
        setProjectType('');
      }
    }, [projectFormMode, handleDisplayProjectForm]);
  
    /* ---------------------------
    ----- FORM FUNCTIONS -----------
    ----------------------------*/

    function closeForm() {
        setLoaderDisplay(false);
        setHandleDisplayProjectForm(false);
        handleLoadProjects();
        setDisplayError(false);
        setDisplayServerError(false);
    }

    /* -------------------------------
    ----- AJOUTS DE CHAMPS -----------
    --------------------------------*/

    const handleAddArtist = () => {
        setArtistsList([...artistsList, { artistFunction: '', artistName: '' }]);
    };
    const handleSupprArtist = (index) => {
        setArtistsList (artistsList.filter((_, i) => i !== index));
    }
    const handleAddProduction = () => {
        setProductionList([...productionList, { prodType: '', prodName: '', prodInfos: '', prodLink: '' }]);
    };
    const handleSupprProduction = (index) => {
        setProductionList (productionList.filter((_, i) => i !== index));
    }
    const handleProdTypeSelectChange = (index, value) => {
        const updatedProductionList = [...productionList];
        updatedProductionList[index].prodType = value;
        setProductionList(updatedProductionList);
    };
    const handleAddPress = () => {
        setPressList([...pressList, { quote: '', mediaName: '', mediaLink: ''}]);
    };
    const handleSupprPress = (index) => {
        setPressList (pressList.filter((_, i) => i !== index));
    }
    const handleAddLink = () => {
        setLinksList([...linksList, { linkName: '', linkUrl: ''}]);
    };
    const handleSupprLink = (index) => {
        setLinksList (linksList.filter((_, i) => i !== index));
    }
    const handleAddDiff = () => {
        setDiffusionList([...diffusionList, { dates: '', city: '', placeName: '', placeLink:''}]);
    };
    const handleSupprDiff = (index) => {
        setDiffusionList (diffusionList.filter((_, i) => i !== index));
    }

    /* --------------------
    ----- IMAGES ----------
    ---------------------*/
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [isMoImageLoaded, setIsMoImageLoaded] = useState(false);
    const [newImage, setNewImage] = useState(null);
    const [newMoImage, setNewMoImage] = useState(null);

    function displaySample() {

        const file = inputProjectImageFileRef.current.files[0];
    
        if (!file) {
            setIsImageLoaded(false);
            setNewImage(null);
            return;
        }
    
        const isImage = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');
    
        if (!isImage && !isVideo) {
            alert("Format non supporté. Utilisez JPG, PNG, WEBP, AVIF ou MP4.");
            inputProjectImageFileRef.current.value = '';
            setIsImageLoaded(false);
            setNewImage(null);
            return;
        }
    
        const MAX_IMAGE_SIZE = 8 * 1024 * 1024;   // 8MB
        const MAX_VIDEO_SIZE = 30 * 1024 * 1024;  // 30MB (backend limit)
    
        if (isImage && file.size > MAX_IMAGE_SIZE) {
            alert("L'image dépasse la taille maximale autorisée (8 Mo).");
            inputProjectImageFileRef.current.value = '';
            setIsImageLoaded(false);
            setNewImage(null);
            return;
        }
    
        if (isVideo && file.size > MAX_VIDEO_SIZE) {
            alert("La vidéo dépasse la taille maximale autorisée (30 Mo).");
            inputProjectImageFileRef.current.value = '';
            setIsImageLoaded(false);
            setNewImage(null);
            return;
        }
    
        if (!file.inRandomSelection) {
            file.inRandomSelection = false;
        }
    
        const id = uuidv4();
    
        file._id = id;
        file.sampleImageUrl = URL.createObjectURL(file);
        file.fileType = file.type;
    
        setIsImageLoaded(true);
        setNewImage(file);
    }

    useEffect(() => {
        if (newImage) {
            projectMainImageSampleRef.current.setAttribute("src", newImage.sampleImageUrl);
            projectMainImageSampleRef.current.setAttribute("alt", "");
        }
    }, [newImage]);

    function displayMoSample() {
        const image = inputProjectMoImageFileRef.current.files[0];
        if (image) {
            const id = uuidv4(); // Générez un identifiant unique
            image._id = id;
            image.sampleImageUrl = URL.createObjectURL(image);
            setNewMoImage(image); // Mettre à jour newMoImage
    
            setIsMoImageLoaded(true);
        } else {
            setIsMoImageLoaded(false);
        }
    }
    
    useEffect(() => {
        if (newMoImage) {
            projectMainMoImageSampleRef.current.setAttribute("src", newMoImage.sampleImageUrl);
            projectMainMoImageSampleRef.current.setAttribute("alt", "");
        }
    }, [newMoImage]);

    function cancelAddImageFile() {
        setNewImage (null);
        setIsImageLoaded(false);
        projectMainImageSampleRef.current.setAttribute("src", "");
        projectMainImageSampleRef.current.setAttribute("alt", "");
    }
    function cancelAddMoImageFile() {
        setNewMoImage (null);
        setIsMoImageLoaded(false);
        projectMainMoImageSampleRef.current.setAttribute("src", "");
        projectMainMoImageSampleRef.current.setAttribute("alt", "");
    }

    function handleAddImageFile() {
        
        if (newImage) {
            const updatedImageFiles = [...imageFiles, newImage];
            setImageFiles(updatedImageFiles);
        }
        setIsImageLoaded(false);
        cancelAddImageFile();
        console.log(imageFiles);
    }

    function handleAddMoImageFile() {
        if (newMoImage) {
            console.log(newMoImage);
            const updatedMoImageFiles = [...moImageFiles, newMoImage];
            setMoImageFiles(updatedMoImageFiles);
        }
        setIsMoImageLoaded(false);
        cancelAddMoImageFile();
        
    }

    /* --------------------------------------
    ----- SOUMISSION DU FORMULAIRE ----------
    ---------------------------------------*/

    function projectFormSubmit(event) {

        event.preventDefault();
        setLoaderDisplay(true);
        const token = window.sessionStorage.getItem('1');
        const projectFormData = new FormData();
        projectFormData.append('title', inputProjectTitleRef.current.value);
        projectFormData.append('subtitle', inputProjectSubtitleRef.current.value);
        projectFormData.append('slug', slugify(inputProjectSlugRef.current.value || inputProjectTitleRef.current.value));
        projectFormData.append('creationDate', inputCreationDateRef.current.value);
        projectFormData.append('projectInfos', inputProjectInfosRef.current.value);
        projectFormData.append('moreInfos', inputMoreInfosRef.current.value);
        projectFormData.append('aboutShow', inputAboutShowRef.current.value);
        projectFormData.append('aboutSceno', inputAboutScenoRef.current.value);
        projectFormData.append('summary', inputSummaryRef.current.value);
        projectFormData.append('projectType', inputProjectTypeRef.current.value);
        projectFormData.append('mainImageIndex', mainImageIndex);
        projectFormData.append('mainMoImageIndex', mainMoImageIndex);
        projectFormData.append('artistsList', JSON.stringify(artistsList));
        projectFormData.append('productionList', JSON.stringify(productionList));
        projectFormData.append('press', JSON.stringify(pressList));
        projectFormData.append('links', JSON.stringify(linksList));
        projectFormData.append('diffusionList', JSON.stringify(diffusionList));

        const newImageFiles = Array.from(imageFiles);
        const newMoImageFiles = Array.from(moImageFiles);
       
        const imagesWithIndex = newImageFiles.map((image, index) => ({
            index,
            image
        }));

        const moImagesWithIndex = newMoImageFiles.map((image, index) => ({
            index,
            image
        }));

        imagesWithIndex.forEach(({ index, image }) => {
            if (image instanceof File) {
                projectFormData.append('images', image);
                projectFormData.append('fileIndexes', index);
                projectFormData.append('fileTypes', image.fileType || image.type || '');
            } else {
                projectFormData.append(`existingImages[${index}]`, JSON.stringify(image));
            }
        });

        moImagesWithIndex.forEach(({ index, image }) => {
            if (image instanceof File) {
                projectFormData.append('moImages', image);
                projectFormData.append('moFileIndexes', index)
            } else {
                projectFormData.append(`existingMoImages[${index}]`, JSON.stringify(image));
            }
        });

        if (
            !inputProjectTitleRef.current.value ||
            !inputProjectTypeRef.current.value ||
            !inputCreationDateRef.current.value
        ) {
            setLoaderDisplay(false);
            setDisplayError(true);
            return;
        }
        else {
            if (projectFormMode==='add') {
                
                fetch(`${API_URL}/api/projects`, {
                    method: "POST",
                    headers: {
                        // 'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token,
                    },
                    body: projectFormData,
                    })
                    .then((response) => {
                        if (response.ok) {
                            return response;       
                        } else {
                            setDisplayServerError(true);
                            throw new Error('La requête a échoué');
                        }
                    })
                    .then(()=> {
                        setLoaderDisplay(false);
                        openValidBox();
                    })
                    .catch((error) => {
                        console.error(error);
                        setDisplayServerError(true);
                        setLoaderDisplay(false);
                });
            } else if (projectFormMode==='edit') {
                fetch(`${API_URL}/api/projects/${projectEdit._id}`, {
                    method: "PUT",
                    headers: {
                        // 'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token,
                    },
                    body: projectFormData,
                    })
                    .then((response) => {
                        if (response.ok) {
                            return response;
                        } else {
                            setDisplayServerError(true);
                            throw new Error('La requête a échoué');
                        }
                    })
                    .then(()=> {
                        setLoaderDisplay(false);
                        openValidBox();
                    })
                    .catch((error) => {
                        console.error(error);
                        setDisplayServerError(true);
                        setLoaderDisplay(false);
                });
            }
        }
    }



    return  (      
        
        <form onSubmit={(event) => projectFormSubmit(event)} method="post" className='projectForm'>
            <button type='button' className='projectForm_stickyCancelButton' onClick={() => setConfirmBoxState(true)}>
                <FontAwesomeIcon icon={faXmark} className='projectForm_stickyCancelButton_icon'/>
            </button>

            {/* WELCOME */}
            <div className='projectForm_welcomeContainer'>
                <p className='projectForm_welcomeContainer_mainWelcome'>Bienvenu chez toi :) </p>
                <img className='projectForm_welcomeContainer_imageWelcome'src={welcomeImage} alt='image de bienvenue'/>
                {/* <p className='projectForm_welcomeContainer_secondWelcome'> Prends-toi tranquille un café avant de te mettre au boulot...</p> */}
            </div>

            {/* INFOS PRINCIPALES */}
            <div className='projectForm_mainInfosContainer'>
                {/* CHAMPS TITRE */}
                <div className='projectForm_mainInfosContainer_textField'>
                    <label htmlFor='inputProjectTitle'>TITRE*</label>
                    <input type='text' id='inputProjectTitle' ref={inputProjectTitleRef} value={projectTitle} onChange={(e) => setProjectTitle(e.target.value)}></input>
                </div>

                {/* CHAMPS SOUS-TITRE */}
                <div className='projectForm_mainInfosContainer_textField'>
                    <label htmlFor='inputProjectSubtitle'>SOUS-TITRE</label>
                    <input type='text' id='inputProjectSubtitle' ref={inputProjectSubtitleRef} value={projectSubtitle} onChange={(e) => setProjectSubtitle(e.target.value)}></input>
                </div>

                 {/* CHAMPS SLUG */}
                 <div className='projectForm_mainInfosContainer_textField'>
                    <label htmlFor='inputProjectSlug'>SLUG</label>
                    <input
                        type='text'
                        id='inputProjectSlug'
                        ref={inputProjectSlugRef}
                        value={projectSlug}
                        onChange={(e) => setProjectSlug(slugify(e.target.value))}
                    />
                </div>

                {/* CHAMPS DATE DE CRÉATION */}
                <div className='projectForm_mainInfosContainer_textField'>
                    <label htmlFor='inputCreationDate'>DATE DE CRÉATION*</label>
                    <input type='month' id='inputCreationDate' ref={inputCreationDateRef} value={creationDate} onChange={(e) => setCreationDate(e.target.value)}></input>
                </div>

                {/* CHAMPS INFOS COMPAGNIE*/}
                <div className='projectForm_mainInfosContainer_textField'>
                    <label htmlFor='inputProjectInfos'>INFORMATIONS COMPAGNIE</label>
                    <input type='text' id='inputProjectInfos' ref={inputProjectInfosRef} value={projectInfos} onChange={(e) => setProjectInfos(e.target.value)}></input>
                </div>

                {/* CHAMPS PLUS D'INFOS*/}
                <div className='projectForm_mainInfosContainer_textField'>
                    <label htmlFor='inputMoreInfos'>PLUS D'INFOS</label>
                    <input type='text' id='inputMoreInfos' ref={inputMoreInfosRef} value={moreInfos} onChange={(e) => setMoreInfos(e.target.value)}></input>
                </div>
                {/* CHAMPS TYPE DE PROJET*/}
                <div className='projectForm_mainInfosContainer_arrayField'>
                    <label htmlFor='inputProjectType'>TYPE DE PROJET*</label>
                    <select id='inputProjectType' 
                            ref={inputProjectTypeRef} 
                            name="projectType"
                            value={projectType} 
                            onChange={(e) => setProjectType(e.target.value)}>
                        <option value=""></option>
                        {projectCategories.map((projectCategory)=>(
                            <option key={projectCategory} value={projectCategory}>{projectCategory}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* IMAGES */}
            <div className='projectForm_imagesFieldsContainer'>
                <div className='projectForm_imagesFieldsContainer_projectImagesContainer'>
                    <p>IMAGES / VIDÉOS DU PROJET</p>
                    <DNDGallery
                        imageFiles={imageFiles}
                        setImageFiles={setImageFiles}
                        mainImageIndex={mainImageIndex}
                        setMainImageIndex={setMainImageIndex}
                        displayClass={'grid'}
                    />                    
                    {imageFiles.length < 15 && 
                    <div className='projectForm_imagesFieldsContainer_projectImagesContainer_imageField'>
                        
                        
                        {/* <input type='file' id='inputProjectImageFile' name="images" ref={inputProjectImageFileRef} onChange={displaySample} style={{ display: 'none' }}></input> */}
                        <input
                            type='file'
                            id='inputProjectImageFile'
                            name='images'
                            ref={inputProjectImageFileRef}
                            accept='image/*,video/*'
                            onChange={displaySample}
                            style={{ display: 'none' }}
                        />
                        <div  className="projectForm_imagesFieldsContainer_projectImagesContainer_imageField_sampleContainer">
                        {newImage && newImage.fileType?.startsWith('image/') && (
                                <img
                                    id='imageSample'
                                    ref={projectMainImageSampleRef}
                                    src={newImage.sampleImageUrl}
                                    alt='aperçu média'
                                />
                            )}

                            {newImage && newImage.fileType?.startsWith('video/') && (
                                <video
                                    id='imageSample'
                                    ref={projectMainImageSampleRef}
                                    src={newImage.sampleImageUrl}
                                    controls
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                />
                            )}
                            <div className={isImageLoaded ? "projectForm_imagesFieldsContainer_projectImagesContainer_imageField_sampleContainer_buttonsSystem--displayOn" :  "projectForm_imagesFieldsContainer_projectImagesContainer_imageField_sampleContainer_buttonsSystem--displayOff"}>
                                <button aria-label="Ajouter l'image" onClick={handleAddImageFile} type="button">AJOUTER</button>
                                <button aria-label="Annuler" onClick={cancelAddImageFile} type="button">ANNULER</button>
                            </div>
                        </div>
                        <label htmlFor='inputProjectImageFile'>{isImageLoaded ? 'CHANGER DE MEDIA (IMAGE OU VIDEO)' : '+ AJOUTER UN MEDIA (IMAGE OU VIDEO)'}</label>
                        <p className='projectForm_imagesFieldsContainer_projectImagesContainer_imageField--formatInfo'>Images : JPG, PNG, WEBP, AVIF, HEIC — max 8 Mo<br/>Vidéos : MP4 (recommandé), MOV, WEBM — max 50 Mo</p>
                    </div>
                    }
                    
                </div>
                {/* <div className='projectForm_imagesFieldsContainer_makingOfImagesContainer'>
                    <p>IMAGES DU PROCESSUS</p>
                    <DNDGallery imageFiles={moImageFiles} setImageFiles={setMoImageFiles} mainImageIndex={mainMoImageIndex} setMainImageIndex={setMainMoImageIndex} displayClass={'row'} /> 
                    {moImageFiles.length < 10 &&
                    <div className='projectForm_imagesFieldsContainer_makingOfImagesContainer_imageField'>
                        <label htmlFor='inputProjectMoImageFile'>{isMoImageLoaded ? 'CHANGER D\'IMAGE' : '+ AJOUTER UNE IMAGE'}</label>
                        <input type='file' id='inputProjectMoImageFile' name="moImages" ref={inputProjectMoImageFileRef} onChange={displayMoSample} style={{ display: 'none' }}></input>
                        <div  className="projectForm_imagesFieldsContainer_makingOfImagesContainer_imageField_sampleContainer">
                            { newMoImage &&
                                <img id='moImageSample' ref={projectMainMoImageSampleRef} src={newMoImage.imageUrl} alt='aperçu image making of'/>
                            }
                            <div className={isMoImageLoaded ? "projectForm_imagesFieldsContainer_makingOfImagesContainer_imageField_sampleContainer_buttonsSystem--displayOn" :  "projectForm_imagesFieldsContainer_makingOfImagesContainer_imageField_sampleContainer_buttonsSystem--displayOff"}>
                                <button aria-label="Ajouter l'image" onClick={handleAddMoImageFile} type="button">AJOUTER</button>
                                <button aria-label="Annuler" onClick={cancelAddMoImageFile} type="button">ANNULER</button>
                            </div>
                        </div>
                    </div>
                    }
                </div> */}
            </div>

            {/* DESCRIPTIFS */}
            <div className='projectForm_descriptionsContainer'>
                {/* CHAMPS A PROPOS DU SPECTACLE*/}
                <div className='projectForm_descriptionsContainer_textField'>
                    <label htmlFor='inputAboutShow'>À PROPOS DU SPECTACLE</label>
                    <textarea className='projectForm_descriptionsContainer_textField_textarea' type='textarea' id='inputAboutShow' ref={inputAboutShowRef} value={aboutShow?.replace(/<br>/g, "\n")} onChange={(e) => setAboutShow(e.target.value)}></textarea>
                </div>

                {/* CHAMPS A PROPOS DE LA SCENO*/}
                <div className='projectForm_descriptionsContainer_textField'>
                    <label htmlFor='inputAboutSceno'>À PROPOS DE LA SCÉNOGRAPHIE</label>
                    <textarea className='projectForm_descriptionsContainer_textField_textarea' type='textarea' id='inputAboutSceno' ref={inputAboutScenoRef} value={aboutSceno?.replace(/<br>/g, "\n")} onChange={(e) => setAboutSceno(e.target.value)}></textarea>
                </div>

                {/* CHAMPS RESUME*/}
                <div className='projectForm_descriptionsContainer_textField'>
                    <label htmlFor='inputSummary'>RÉSUMÉ</label>
                    <textarea className='projectForm_descriptionsContainer_textField_textarea' type='textarea' id='inputSummary' ref={inputSummaryRef} value={summary?.replace(/<br>/g, "\n")} onChange={(e) => setSummary(e.target.value)}></textarea>
                </div>
            </div>

            {/* TABLEAUX */}
            <div className='projectForm_arraysContainer'>
                {/* CHAMPS DISTRIBUTION*/}
                <div className='projectForm_arraysContainer_arrayField'>
                    <p> DISTRIBUTION </p>
                    {artistsList.map((artist, index) => (
                        <div key={index} className='projectForm_arraysContainer_arrayField_fields'>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectArtistFunction${index}`}>FONCTION</label>
                                <input
                                    type='text'
                                    id={`inputProjectArtistFunction${index}`}
                                    value={artist.artistFunction}
                                    onChange={(e) => {
                                        const updatedArtistsList = [...artistsList];
                                        updatedArtistsList[index].artistFunction = e.target.value;
                                        setArtistsList(updatedArtistsList);
                                    }}
                                ></input>
                            </div>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectArtistName${index}`}>NOMS</label>
                                <input
                                    type='text'
                                    id={`inputProjectArtistName${index}`}
                                    value={artist.artistName}
                                    onChange={(e) => {
                                        const updatedArtistsList = [...artistsList];
                                        updatedArtistsList[index].artistName = e.target.value;
                                        setArtistsList(updatedArtistsList);
                                    }}
                                ></input>
                            </div>
                            <button type='button' onClick={() => handleSupprArtist(index)}>SUPPRIMER</button>
                        </div>              
                    ))}
                    <button type='button' onClick={() =>handleAddArtist()} >+ AJOUTER UN ARTISTE</button>
                </div>
                {/* CHAMPS PRODUCTION*/}
                <div className='projectForm_arraysContainer_arrayField'>
                    <p> PRODUCTION </p>
                    {productionList.map((production, index) => (
                        <div key={index} className='projectForm_arraysContainer_arrayField_fields'>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectProductionName${index}`}>NOM</label>
                                <input
                                    type='text'
                                    id={`inputProjectProductionName${index}`}
                                    value={production.prodName}
                                    onChange={(e) => {
                                        const updatedProductionList = [...productionList];
                                        updatedProductionList[index].prodName = e.target.value;
                                        setProductionList(updatedProductionList);
                                    }}
                                ></input>
                            </div>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectProductionLink${index}`}>LIEN</label>
                                <input
                                    type='text'
                                    id={`inputProjectProductionLink${index}`}
                                    value={production.prodLink}
                                    onChange={(e) => {
                                        const updatedProductionList = [...productionList];
                                        updatedProductionList[index].prodLink = e.target.value;
                                        setProductionList(updatedProductionList);
                                    }}
                                ></input>
                            </div>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectProductionLink${index}`}>INFOS</label>
                                <input
                                    type='text'
                                    id={`inputProjectProductionInfos${index}`}
                                    value={production.prodInfos}
                                    onChange={(e) => {
                                        const updatedProductionList = [...productionList];
                                        updatedProductionList[index].prodInfos = e.target.value;
                                        setProductionList(updatedProductionList);
                                    }}
                                ></input>
                            </div>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectProductionType${index}`}>TYPE</label>
                                <select id={`inputProjectProductionType${index}`} 
                                        defaultValue={projectFormMode==='edit'? production.prodType : ""}
                                        onChange={(e) => handleProdTypeSelectChange(index, e.target.value)}>
                                    <option value=""></option>
                                    {productionCategories.map((productionCategory)=>(
                                    <option value={productionCategory}>{productionCategory}</option>
                                    ))}
                                </select>
                            </div>
                            <button type='button' onClick={() => handleSupprProduction(index)}>SUPPRIMER</button>
                        </div>              
                    ))}
                    <button type='button' onClick={() =>handleAddProduction()} >+ AJOUTER UN MEMBRE DE L'EQUIPE DE PROD</button>
                </div>
                
                {/* CHAMPS PRESSE*/}
                <div className='projectForm_arraysContainer_arrayField'>
                    <p> PRESSE </p>
                    {pressList.map((press, index) => (
                        <div key={index} className='projectForm_arraysContainer_arrayField_fields'>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectPressQuote${index}`}>EXTRAIT</label>
                                <input
                                    type='textarea'
                                    id={`inputProjectPressQuote${index}`}
                                    value={press.quote}
                                    onChange={(e) => {
                                        const updatedPressList = [...pressList];
                                        updatedPressList[index].quote = e.target.value;
                                        setPressList(updatedPressList);
                                    }}
                                ></input>
                            </div>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectPressMediaName${index}`}>MEDIA</label>
                                <input
                                    type='text'
                                    id={`inputProjectPressMediaName${index}`}
                                    value={press.mediaName}
                                    onChange={(e) => {
                                        const updatedPressList = [...pressList];
                                        updatedPressList[index].mediaName = e.target.value;
                                        setPressList(updatedPressList);
                                    }}
                                ></input>
                            </div>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectPressMediaLink${index}`}>LIEN</label>
                                <input
                                    type='text'
                                    id={`inputProjectPressMediaLink${index}`}
                                    value={press.mediaLink}
                                    onChange={(e) => {
                                        const updatedPressList = [...pressList];
                                        updatedPressList[index].mediaLink = e.target.value;
                                        setPressList(updatedPressList);
                                    }}
                                ></input>
                            </div>
                            <button type='button' onClick={() => handleSupprPress(index)}>SUPPRIMER</button>
                        </div>              
                    ))}
                    <button type='button' onClick={() =>handleAddPress()} >+ AJOUTER UN ARTICLE DE PRESSE</button>
                </div>

                {/* CHAMPS LIENS*/}
                <div className='projectForm_arraysContainer_arrayField'>
                    <p> LIENS VIDÉOS/COMPAGNIE/ETC. </p>
                    {linksList.map((link, index) => (
                        <div key={index} className='projectForm_arraysContainer_arrayField_fields'>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectLinkName${index}`}>LABEL</label>
                                <input
                                    type='text'
                                    id={`inputProjectLinkName${index}`}
                                    value={link.linkName}
                                    onChange={(e) => {
                                        const updatedLinksList = [...linksList];
                                        updatedLinksList[index].linkName = e.target.value;
                                        setLinksList(updatedLinksList);
                                    }}
                                ></input>
                            </div>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectLinkUrl${index}`}>URL</label>
                                <input
                                    type='text'
                                    id={`inputProjectLinkUrl${index}`}
                                    value={link.linkUrl}
                                    onChange={(e) => {
                                        const updatedLinksList = [...linksList];
                                        updatedLinksList[index].linkUrl = e.target.value;
                                        setLinksList(updatedLinksList);
                                    }}
                                ></input>
                            </div>
                            <button type='button' onClick={() => handleSupprLink(index)}>SUPPRIMER</button>
                        </div>              
                    ))}
                    <button type='button' onClick={() =>handleAddLink()} >+ AJOUTER UN LIEN</button>
                </div>

                {/* CHAMPS DIFFUSION*/}
                <div className='projectForm_arraysContainer_arrayField'>
                    <p> DIFFUSION </p>
                    {diffusionList.map((diff, index) => (
                        <div key={index} className='projectForm_arraysContainer_arrayField_fields'>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectDiffDates${index}`}>DATES</label>
                                <input
                                    type='text'
                                    id={`inputProjectDiffDates${index}`}
                                    value={diff.dates}
                                    onChange={(e) => {
                                        const updatedDiffusionList = [...diffusionList];
                                        updatedDiffusionList[index].dates = e.target.value;
                                        setDiffusionList(updatedDiffusionList);
                                    }}
                                ></input>
                            </div>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectDiffCity${index}`}>VILLE</label>
                                <input
                                    type='text'
                                    id={`inputProjectDiffCity${index}`}
                                    value={diff.city}
                                    onChange={(e) => {
                                        const updatedDiffusionList = [...diffusionList];
                                        updatedDiffusionList[index].city = e.target.value;
                                        setDiffusionList(updatedDiffusionList);
                                    }}
                                ></input>
                            </div>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectPlaceName${index}`}>LIEU</label>
                                <input
                                    type='text'
                                    id={`inputProjectPlaceName${index}`}
                                    value={diff.placeName}
                                    onChange={(e) => {
                                        const updatedDiffusionList = [...diffusionList];
                                        updatedDiffusionList[index].placeName = e.target.value;
                                        setDiffusionList(updatedDiffusionList);
                                    }}
                                ></input>
                            </div>
                            <div className='projectForm_arraysContainer_arrayField_fields_line'>
                                <label htmlFor={`inputProjectPlaceLink${index}`}>URL</label>
                                <input
                                    type='text'
                                    id={`inputProjectPlaceLink${index}`}
                                    value={diff.placeLink}
                                    onChange={(e) => {
                                        const updatedDiffusionList = [...diffusionList];
                                        updatedDiffusionList[index].placeLink = e.target.value;
                                        setDiffusionList(updatedDiffusionList);
                                    }}
                                ></input>
                            </div>
                            <button type='button' onClick={() => handleSupprDiff(index)}>SUPPRIMER</button>
                        </div>              
                    ))}
                    <button type='button' onClick={() =>handleAddDiff()} >+ AJOUTER UN LIEU</button>
                </div>
                <ErrorText errorText={"Une erreur s\'est produite"} state={displayServerError}/>
                <ErrorText errorText={"Tous les champs marqués d'une * doivent être remplis"} state={displayError}/>
                <div className='projectForm_buttons'>
                    <button type='submit'>ENVOYER</button>
                    <button type='button' onClick={() => setConfirmBoxState(true)}>SORTIR</button>
                </div>
            </div>
            <div className={loaderDisplay===true?'projectForm_loaderContainer--displayOn':'projectForm_loaderContainer--displayOff'} >
                <Loader className='loader' loaderDisplay={loaderDisplay}/>
            </div>
            <div>
                <ConfirmBox
                    affirmativeChoice = {closeForm}
                    attribut = {null}
                    confirmBoxState = {confirmBoxState}
                    negativeChoice = {closeConfirmBox}
                />
            </div>
            <ValidBox validBoxState={displayValidBox}/>
        </form>
    )
}

export default ProjectForm